export default {
  MTN: '/assets/images/logos/providers/logo-momo.jpg',
  ORANGE: '/assets/images/logos/providers/logo-orange-money.jpg',
  MESOMB: '/assets/images/logos/providers/logo-mesomb.png',
  AIRTEL: '/assets/images/logos/providers/logo-airtelmoney.jpg',
  TMONEY: '/assets/images/logos/providers/logo-togocom.png',
  MOOV: '/assets/images/logos/providers/logo-moov.png',
  VODACOM: '/assets/images/logos/providers/logo-vodacom.png',
  WAVE: '/assets/images/logos/providers/logo-wave.jpg',
  MPESA: '/assets/images/logos/providers/logo-mpesa.png',
  TNM: '/assets/images/logos/providers/logo-tnm.png',
  YAS: '/assets/images/logos/providers/logo-yas.png',
  HALOTEL: '/assets/images/logos/providers/logo-halotel.png',
  ZAMTEL: '/assets/images/logos/providers/logo-zamtel.png',
  MOBICASH: '/assets/images/logos/providers/logo-mobicash.png',
  MAVIANCE: '/assets/images/logos/providers/logo-maviance.png',
  GLOTELHO: '/assets/images/logos/providers/logo-glotelho.png',
  USDT: '/assets/images/logos/providers/logo-usdt.png',
  YANGO: '/assets/images/logos/providers/logo-yango.png',
  YOOMEE: '/assets/images/logos/providers/logo-yoomee.jpg',
} as Record<string, string>;
